import React from "react";
import OTPFeature from "../FormFields/OTPFeature";

interface Props {
  firstSubtitle?: string;
  subtitle?: string;
  email?: string;
  otpLength?: number;
  resendText?: string;
  logoutText?: string;
  error?: string;
  isLoading?: boolean;
  onOtpSubmit: (code: string) => void;
  onResend?: () => void;
  onLogout?: () => void;
}
const Fields: React.FC<Props> = ({
  firstSubtitle = "We just emailed you",
  subtitle = "Please enter the code we emailed you",
  email = "",
  otpLength = 4,
  resendText = "Resend",
  logoutText = "Logout",
  error,
  isLoading,
  onOtpSubmit,
  onResend,
  onLogout,
}) => {
  return (
    <form className="flex flex-col w-full max-w-[390px] h-[325px] gap-[24px] mx-auto">
      <div className="flex flex-col gap-[12px]">
        <p className="text-black font-normal text-[24px] leading-[24px] tracking-normal text-center">
          {firstSubtitle}
        </p>
        <p className="text-secondary font-normal text-[16px] leading-[24px] tracking-normal text-center">
          {subtitle}{" "}
          <span className="text-black font-normal text-[16px] leading-[24px] tracking-normal block pt-[4px]">
            {email}
          </span>
        </p>
      </div>

      <OTPFeature 
        length={otpLength} 
        onSubmit={onOtpSubmit} 
        label="Confirmation code"
        error={error}
        isLoading={isLoading}
      />

      <div className="flex justify-center items-center gap-[4px]">
        <button
          type="button"
          onClick={onResend}
          className="text-center text-primary text-[16px] leading-[21px] font-medium flex flex-row items-center"
        >
          {resendText}
        </button>
        <span className="text-secondary text-[14px] leading-[21px]">or</span>
        <button
          type="button"
          onClick={onLogout}
          className="text-center text-primary text-[16px] leading-[21px] font-medium flex flex-row items-center"
        >
          {logoutText}
        </button>
      </div>
    </form>
  );
};

export default Fields;
